<template>
  <div class="card-detail" :id="`${category}-${cardContent.contentid}`">
    <!-- <div class="card-detail-box" :style="{
        'height': `${cardHeight}px`
      }"> -->
    <div class="card-detail-box">
      <div
        class="card-detail-box-contain"
        :style="{
              'background-image': `url(${ getPoster(cardContent,'LANDSCAPE') })`
            }"
      >
        <div class="deatil-container">
          <div class="content-close">
            <img
              src="@/assets/icons/Close@1x.png"
              alt="closes"
              class="header-close"
              @click="closeDetailCard()"
            />
          </div>
          <div class="card-tab-content">
            <div
              :id="cardContent.title+'Overview'"
              class="tabcontent"
              :class="'Overview' === activeTabName ? 'activetab' : ''"
            >
              <div class="overview-class">
                <div class="overview-left">
                  <div class="overview-left-content">
                    <p class="movie-title">{{ cardContent.title }}</p>
                    <div class="card-detail-progress" v-if="progress && purchaseDetails">
                      <div
                        class="progress-percent"
                        :id="`progress-${cardContent.contentid}`"
                        :style="{ width: progress + '%' }"
                      ></div>
                    </div>
                    <div class="movie-tags">
                      <p>{{cardContent.category}}</p>
                      <p>{{cardContent.year}}</p>
                      <p
                        v-for="(lang,index) in languages"
                        :key="lang"
                        :style="(index != 0) ? 'padding-left: 10px;border-left:1.5px solid rgba(255, 252, 252, 0.76);margin-right:10px;': 'margin-right:10px;'"
                      >{{lang}}</p>
                    </div>
                    <!-- Content Crew -->
                    <div v-for="(castandcrew, index) in getCrew()" :key="index">
                      <p class="starring">{{castandcrew.role}} :</p>
                      <p class="castncrew">{{ castandcrew.names }}</p>
                    </div>
                    <p
                      v-if="cardContent.description"
                      class="content-description"
                    >{{cardContent.description}}</p>
                    <!-- Share Icons -->
                    <div class="detail-card-ioncs row">
                      <div class="col-lg-2 col-md-2 col-sm-3 buttonHover">
                        <div class="trailer-btn">
                          <!--remove inline style on this button when you enable like dislike buttons important-->
                          <button type="button" class="watchlist-btn" @click="watchTrailer" style="background: black;border: none;">
                            <img src="@/assets/icons/Ic_trailer.svg" alt="watchlist" />
                            <p class="like-tag" style="color:white">Trailer</p>
                          </button>
                        </div>
                      </div>
                      <!-- <div class="col-lg-2 col-md-2 col-sm-3 buttonHover">
                        <CardLikeBtn color="WHITE" container="Detail" :content="cardContent" />
                      </div>
                      <div class="col-lg-2 col-md-2 col-sm-3 buttonHover">
                        <CardDisLikeBtn color="WHITE" container="Detail" :content="cardContent" />
                      </div> -->
                      <div class="col-lg-2 col-md-2 col-sm-3 buttonHover">
                        <Share class="card-share-btn" :content="cardContent" />
                      </div>
                    </div>
                    <!-- Book Button -->
                    <div class="card-book-btn" v-if="!purchaseDetails && showPurchaseButton">
                      <button
                        class="btn-lg-primary"
                        ref="bookNowBtn"
                        @click="routeCard(cardContent)"
                      >{{ (purchaseDetails && subscriberid) ? 'Watch Now' : `Purchase for ${ contentPrice.currencysymbol } ${ contentPrice.amount / 100 }`}}</button>
                    </div>
                    <div class="purchase-details" v-if="purchaseDetails">
                      <div class="row ml0">
                        <p class="title">Purchase Details</p>
                        <img
                          id="purchaseArrow"
                          @click="toggleDetails"
                          class="arrow"
                          src="@/assets/icons/expandarrow.png"
                        />
                      </div>
                      <transition v-if="showPurchaseDetail" name="slide">
                        <div>
                          <div class="row ml0">
                            <p class="label">Expires on</p>
                            <p class="value">{{formateDate()}}</p>
                          </div>
                          <div class="row ml0">
                            <p class="label">Transaction ID-</p>
                            <p class="value">{{cardContent.purchaseDetails.ticketid}}</p>
                          </div>
                          <div class="row ml0">
                            <p class="label">Total Amount Paid</p>
                            <p
                              class="value"
                            >{{ contentPrice.currencysymbol }}{{cardContent.purchaseDetails.ticketprice / 100}}</p>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </div>
                <div class="overview-right">
                  <!-- <img :src="getPoster(cardContent,'PORTRAIT')" width="100%" height="100%" /> -->
                  <img
                    class="play"
                    @click.prevent="playContent(cardContent)"
                    src="@/assets/icons/sdgPlay.svg"
                    width="20%"
                    v-if="purchaseDetails"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { EventBus } from "@/main";
import firebase from "firebase/app";
import "firebase/database";
import Utility from "@/mixins/Utility";

export default {
  name: "ContentDetailCard",
  props: {
    closePopupEvent: {
      type: Function
    },
    cardContent: {
      type: Object
    },
    category: {
      type: String
    }
  },
  data() {
    return {
      cardHeight: 500,
      cardTabs: ["More", "About", "Episodes", "Overview"],
      activeTabName: "Overview",
      aboutCardTabs: ["Trailers", "Cast&crew", "Reviews", "Posters"],
      activeAboutTabName: "Trailers",
      showPurchaseDetail: false,
      purchaseDetails: null,
      languages: [],
      showPurchaseButton: true,
      contentPrice: null,
      progress: null
    };
  },
  components: {
    CardDisLikeBtn: () => import("@/components/Templates/dislikeBtn.vue"),
    CardLikeBtn: () => import("@/components/Templates/likeBtn.vue"),
    Share: () => import("@/components/Slots/share.vue")
  },
  watch: {
    cardContent() {
      EventBus.$emit("closeAllArrow");
      this.purchaseDetails = null;
      this.progress = this.cardContent.progress
        ? this.cardContent.progress
        : null;

      if (this.cardContent.purchaseDetails) {
        this.purchaseDetails = this.cardContent.purchaseDetails;
      }
      this.showArrow();
      this.getLanguage();
      this.getContentCurrency();
      setTimeout(() => {
        this.reset();
      }, 100);
    },
    currency() {
      if (this.currency) {
        this.getContentCurrency();
      }
    }
  },
  created() {
    EventBus.$emit("closeAllArrow");
    //
    this.getLanguage();
    this.fetchCardHeight();
    this.checkContentType();

    if (this.cardContent.purchaseDetails) {
      this.purchaseDetails = this.cardContent.purchaseDetails;
      // console.log('purchase details', this.purchaseDetails);
    }

    EventBus.$on(`ticketStatus-${this.cardContent.contentid}`, data => {
      this.showPurchaseButton = false;
      // this.checkUserBoughtTicket();
      if (data) {
        this.purchaseDetails = data;
        this.cardContent.ticketStatus = true;
        this.cardContent.purchaseDetails = data;
      }
    });
    if (this.subscriberid) {
      this.getCardProgress();
    }
    if (this.currency) {
      this.getContentCurrency();
    }
  },
  mounted() {
    this.showArrow();
    // $('html,body').animate({scrollTop: $(`${this.category}-${this.cardContent.contentid}`).offset().top},800);
    var elmnt = document.getElementById(
      `${this.category}-${this.cardContent.contentid}`
    );

    elmnt.scrollIntoView({ block: "start" });
  },
  computed: {
    ...mapGetters(["vendorid", "subscriberid", "currency"])
  },
  methods: {
    ...mapMutations(["commitNewTicket"]),
    ...mapActions(["actListTicket"]),
    getContentCurrency() {
      this.contentPrice = this.getContentPrice(this.cardContent);
    },
    watchTrailer() {
      EventBus.$emit("showPlayer", this.cardContent, "T");
    },
    playContent() {
      EventBus.$emit("showPlayer", this.cardContent);
    },
    getCardProgress() {
      let content = this.cardContent;
      let contentid = content.contentid;
      let contenttype = content.contenttype;
      // Create the firebase paths to fetch the data
      let path = `${this.vendorid}/subscriber/${this.subscriberid}/content/${contentid}`;

      firebase
        .database()
        .ref(path)
        .on("value", snapshot => {
          if (snapshot.val()) {
            let response = snapshot.val();
            if (
              (response.status === "INPROGRESS" ||
                response.status === "COMPLETED") &&
              response.watchedduration > 9 &&
              new Date(response.expiry) >= new Date()
            ) {
              let duration = response.duration;
              let watched = response.watchedduration;
              let progress = (watched / duration) * 100;
              if (progress > 0 && progress < 100) {
                this.progress = progress;
              }
            } else if (response.status === "COMPLETED") {
              this.progress = null;
            } else {
              this.progress = null;
            }
          }
        });
    },
    formateDate() {
      let dateString = "";
      if (this.cardContent.purchaseDetails.expiry) {
        let fromDate = new Date(this.cardContent.purchaseDetails.expiry);
        let months = [
          "JAN",
          "FEB",
          "MAR",
          "APR",
          "MAY",
          "JUN",
          "JUL",
          "AUG",
          "SEP",
          "OCT",
          "NOV",
          "DEC"
        ];
        dateString =
          fromDate.getDate() +
          " " +
          months[fromDate.getMonth()] +
          " " +
          fromDate.getFullYear();
      }
      return dateString;
    },
    getCurrency(currency) {
      let str = "";
      switch (currency) {
        case "INR":
          str = "₹";
          break;
        default:
          str = "$";
          break;
      }
      return str;
    },
    toggleDetails() {
      if (!this.showPurchaseDetail) {
        this.showPurchaseDetail = true;
        document.getElementById("purchaseArrow").style.transform =
          "rotate(180deg)";
      } else {
        this.showPurchaseDetail = false;
        document.getElementById("purchaseArrow").style.transform =
          "rotate(0deg)";
      }
    },
    reset() {
      this.cardTabs = ["More", "About", "Episodes", "Overview"];
      this.checkContentType();
      this.activeTabName = "Overview";
      this.activeAboutTabName = "Trailers";
    },
    closeDetailCard() {
      EventBus.$emit("closeAllArrow");
      this.closePopupEvent();
    },
    showArrow() {
      // setTimeout(() => {
      EventBus.$emit(
        `show-${this.category}-${this.cardContent.title}-downarrow`
      );
      // }, 100);
    },
    routeCard(content) {
      let status = content.contentstatus;
      if (status === "INACTIVE") return;
      if (!this.subscriberid) {
        let data = {
          popup: "PaymentPopup",
          contentid: this.cardContent.contentid
        };
        EventBus.$emit("LoginPopup", data);
      } else if (this.subscriberid && !this.purchaseDetails) {
        let data = {
          content: this.cardContent
        };
        EventBus.$emit("PaymentPopup", data);
      } else if (this.subscriberid && this.purchaseDetails) {
        EventBus.$emit("showPlayer", this.content);
      }
    },
    renderAboutTab(tab) {
      this.activeAboutTabName = tab;
    },
    renderTab(tab) {
      this.activeTabName = tab;
    },
    checkContentType() {
      if (this.cardContent.contenttype == "MOVIE") {
        let temp = this.cardTabs.filter(ele => ele != "Episodes");
        this.cardTabs = temp;
      }
    },
    comaSeparatedNames(names) {
      let length = names.length;
      let nameString = "";
      for (let index = 0; index < length; index++) {
        if (nameString) {
          nameString += " , " + names[index].castncrewname;
        } else {
          nameString = names[index].castncrewname;
        }
      }
      return nameString;
    },
    getCrew() {
      let castAndCrew = null;
      let castAndCrewList = [];
      if (!this.cardContent.castncrew) return castAndCrew;
      let castArray = this.cardContent.castncrew.filter(
        cr => cr.castncrewtype == "CAST"
      );
      let crewArray = this.cardContent.castncrew.filter(
        cr => cr.castncrewtype == "CREW"
      );
      if (castArray.length > 0) {
        let data = {
          role: "Starring",
          names: castArray
        };
        castAndCrewList.push(data);
      }
      if (crewArray.length > 0) {
        crewArray.forEach(element => {
          let index = castAndCrewList.findIndex(
            ele => ele.role === element.castncrewrole
          );
          if (index > -1) {
            castAndCrewList[index].names.push(element);
          } else {
            let data = {
              role: element.castncrewrole,
              names: [element]
            };
            castAndCrewList.push(data);
          }
        });
      }
      castAndCrewList.forEach(ele => {
        ele.names = this.comaSeparatedNames(ele.names);
      });
      return castAndCrewList;
    },
    fetchCardHeight() {
      if (this.isMobile()) {
        if (window.innerWidth < 1990) {
          this.cardHeight = 550;
          if (this.cardContent.description.length > 180) {
            this.cardHeight += 200;
          }
          if (this.getCrew() && this.getCrew().length > 2) {
            this.cardHeight += 120;
          }
        }
      } else {
        let bodyWidth = document.body.offsetWidth - 400;
        let cardHeight = Math.round(bodyWidth / (16 / 9));
        if (cardHeight) {
          this.cardHeight = cardHeight + (this.isTablet() ? 330 : 30);
          // this.cardHeight = cardHeight;
          if (this.cardContent.description.length > 190) {
            if (this.getCrew() && this.getCrew().length > 2) {
              this.cardHeight += 100;
            } else {
              this.cardHeight += 70;
            }
          }
        }
      }
    },
    getLanguage() {
      let contentLanguage = "";

      this.cardContent.tags.forEach(element => {
        let str = element.includes("Lang");
        if (str) {
          let str2 = element.split("-");
          if (str2 && str2.length > 1) {
            contentLanguage = str2[1].split("|");
          }
        }
      });
      this.languages = contentLanguage;
    },
    getPoster(content, type) {
      if (content.posters.length) {
        let landscapeposters = content.posters.filter(
          pos => pos.orientation === type
        );
        if (landscapeposters.length) {
          let posterIndex = landscapeposters.findIndex(
            pos => pos.quality === "HD"
          );
          if (posterIndex > -1) {
            return landscapeposters[posterIndex].url;
          } else {
            return landscapeposters[0].url;
          }
        }
      }
    }
  },
  mixins: [Utility]
};
</script>

<style lang="scss" scoped>
.ml0 {
  margin-left: 0;
}
.card-detail {
  margin: 0 0px;
  border-radius: 5px;
  // margin-bottom: 20px;
  // width: 100%;
  // background: radial-gradient(circle, rgba(0,0,0,0) 0%, rgba(0,0,0,0.9) 100%), linear-gradient(221.79deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.2) 100%), linear-gradient(186.68deg, rgba(0,0,0,0) 0%, #000000 100%), linear-gradient(270deg, rgba(0,0,0,0) 0%, #000000 100%);
}
.card-detail-box {
  position: relative;
  border-radius: 8px;
  // overflow: hidden;
}
.card-detail-box-contain {
  // position: absolute;
  // top: 0;
  // left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  // background-position: center;
}
.content-close {
  cursor: pointer;
  img {
    right: 2%;
    padding: 15px;
    z-index: 100;
    position: absolute;
    top: 2%;
  }
}
.deatil-container {
  width: 100%;
  height: 100%;
  // background: linear-gradient(to right, rgba(0, 0, 0, 0.7), transparent);
}
.tablink {
  background-color: black;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 30px 10px;
  width: 15%;
  float: right;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.77);
  font-family: "HelveticaNeueMedium";
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.37px;
  line-height: 25px;
}
.card-tab-content {
  height: 100%;
}
/* Style the tab content */
.tabcontent {
  display: none;
  height: 100%;
}
.card-tab {
  bottom: 0;
  position: absolute;
  right: 0;
  width: 100%;
  background: black;
  button:first-child {
    margin-right: 3%;
  }
}
.activetabname {
  span {
    padding-bottom: 5px;
    border-bottom: 2px solid;
    color: white;
  }
}
.activetab {
  display: block !important;
}
.inactivetab {
  display: none;
}
.tabstyle {
  background-color: rgba(0, 0, 0, 0.8);
}
.overview-class {
  display: flex;
  height: 100%;
  background: linear-gradient(90deg, #000 0, #000 35%, rgba(255, 166, 166, 0));
  // background: linear-gradient(to right, black, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0));
}
.overview-left {
  flex: 1.1;

  // background-color: black;
  // background-image: url('../../assets/icons/background.png');
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: -20px;
  // background: linear-gradient(to right, black, rgba(0,0,0,1),rgba(0,0,0,1),rgba(0,0,0,1), rgba(0,0,0,0.8), rgba(0,0,0,0));
  &::after {
    width: 10%;
    background: linear-gradient(
      to right,
      black,
      rgba(0, 0, 0, 1),
      rgba(0, 0, 0, 1),
      rgba(0, 0, 0, 1),
      rgba(0, 0, 0, 1),
      rgba(0, 0, 0, 0)
    );
  }

  .overview-left-content {
    // padding: 10% 5% 1% 10%;
    padding: 5%;
    .starring {
      float: left;
      margin-right: 5px;
      opacity: 0.8;
      color: #ffffff;
      font-family: "ProximanovaSemibold";
      font-size: 18px;
      line-height: 28px;
    }
    .castncrew {
      word-break: break-word;
      opacity: 0.8;
      color: #ffffff;
      font-family: "ProximanovaRegular";
      font-size: 16px;
      line-height: 28px;
    }
    .content-description {
      opacity: 0.8;
      color: #ffffff;
      font-family: "ProximanovaRegular";
      font-size: 16px;
      line-height: 26px;
      margin: 10px 0 20px 0;
    }
    .detail-card-ioncs {
      margin: 25px 0 10px 0;
      .card-share-btn {
        // float: left;
        margin-right: 15px;
      }
      .buttonHover {
        &:hover {
          transform: translateY(-2px);
          transition: 0.2s;
        }
      }
    }
    .card-book-btn {
      width: 60%;
      button {
        margin-top: 5%;
        letter-spacing: 0.44px;
        line-height: 29px;
      }
    }
  }
}
.movie-title {
  color: #ffffff;
  font-size: 40px;
  font-weight: bold;
  letter-spacing: 0.74px;
  line-height: 49px;
  text-transform: uppercase;
  font-family: "ProximanovaBold";
  word-break: break-word;
}
.rating {
  display: flex;
  margin: 10px 0;
}
.rating-box {
  width: 20px;
  height: 20px;
  border: 1px solid rgba(255, 255, 255, 0.77);
  margin-right: 5px;
}
.rating-no {
  opacity: 0.76;
  color: #ffffff;
  font-family: "HelveticaNeueMedium";
  font-size: 20px;
  line-height: 24px;
  margin-top: -2px;
  margin-left: 5px;
}
.movie-tags {
  // display: flex;
  clear: both;
  display: table;
  margin: 15px 0;
  p {
    float: left;
    opacity: 0.76;
    color: #ffffff;
    font-family: "ProximanovaSemibold";
    font-size: 18px;
    line-height: 15px;
    margin-right: 25px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
}
.overview-right {
  flex: 1;
  img.play {
    cursor: pointer;
    margin-top: 40%;
    margin-left: 40%;
    opacity: 0.85;
    &:hover {
      opacity: 1;
    }
  }
}
.About-content {
  padding: 5% 5% 0 8%;
}
.abouttablink {
  text-transform: uppercase;
  letter-spacing: 1px;
  background-color: transparent;
  padding: 7px 20px;
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.77);
  border: 1px solid rgba(255, 255, 255, 0.77);
  margin-right: 5px;
  cursor: pointer;
  font-family: "HelveticaNeueMedium";
}
.aboutactivetab {
  color: #ffffff;
  border: 2px solid #ffffff;
  font-size: 14px;
  font-weight: bold;
  line-height: 19px;
}
/* Style the tab content */
.about-tab {
  display: none;
  height: 100%;
}
.more-like-this {
  color: #ffffff;
  font-family: "HelveticaNeueMedium";
  font-size: 40px;
  letter-spacing: 0.74px;
  line-height: 49px;
  text-transform: uppercase;
}
.card-detail-progress {
  width: 70%;
  height: 2px;
  background-color: rgba(167, 167, 167, 0.5);
  margin: 20px 0;
  .progress-percent {
    height: 100%;
    background-color: #4558dd;
  }
}
.purchase-details {
  .title {
    color: rgba(255, 255, 255, 0.55);
    font-family: "ProximanovaSemibold";
    font-size: 20px;
    letter-spacing: 0.44px;
    line-height: 29px;
    float: left;
  }
  .arrow {
    width: 16px;
    margin-left: 10px;
    margin-top: 5px;
    cursor: pointer;
    transition: 0.5s;
  }
  .label {
    color: rgba(255, 255, 255, 0.55);
    font-family: "ProximanovaSemibold";
    font-size: 16px;
    letter-spacing: 0.44px;
    line-height: 29px;
    float: left;
    margin-right: 15px;
  }
  .value {
    color: rgba(255, 255, 255, 0.8);
    font-family: "ProximanovaSemibold";
    font-size: 16px;
    letter-spacing: 0.44px;
    line-height: 29px;
    float: left;
  }
}
.slide-enter-active {
  -moz-transition-duration: 0.2s;
  -webkit-transition-duration: 0.2s;
  -o-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.2s;
  -webkit-transition-duration: 0.2s;
  -o-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -moz-transition-timing-function: ease-out;
  -webkit-transition-timing-function: ease-out;
  -o-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}

.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
.trailer-btn {
  img {
    width: 30px;
  }
  p {
    color: #ffffff;
    font-family: "ProximanovaRegular";
    font-size: 18px;
    font-weight: bold;
    line-height: 24px;
    text-align: center;
  }
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .card-detail-box-contain {
  // position: absolute;
  // top: 0;
  // left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  }
  .card-detail-box {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  }
  .overview-class {
    // display: block;
    // background: black;
  }
  .overview-left {
    // background: black;
    flex: 1;
    margin-top: 0px;
    .overview-left-content {
      .card-book-btn {
        width: 95%;
        margin-bottom: 20px;
        button {
          font-size: 20px;
        }
      }
    }
  }
  .overview-right {
  flex: 1;
    img.play {
      cursor: pointer;
      width: 60px;
      margin: 0px;
      position: absolute;
      top: 40%;
      right: 20%;
    }
  }
  .movie-tags {
    p {
      margin-bottom: 10px;
    }
  }
  .overview-right {
    flex: 0;
  }
  .purchase-details {
    margin-bottom: 20px;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 601px) and (max-width: 992px) {
  .overview-left {
    flex: 2.5;
  }
  .card-book-btn {
    width: 70%;
  }
  .overview-right {
    position: relative;
    img.play {
      cursor: pointer;
      // margin-top: 70%;
      // cursor: pointer;
      // margin-top: 70%;
      width: 60px;
      position: absolute;
      top: 20%;
      right: 40%;
    }
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .card-detail-box {
  position: relative;
  border-radius: 8px;
  // overflow: hidden;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .card-detail-box {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .card-detail-box {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  }
}
// 4k
@media screen and (min-width: 1900px) {
  .card-detail-box {
    height: 675px !important;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
  }
  .overview-left {
    .overview-left-content {
      .starring {
        font-size: 20px;
      }
      .castncrew {
        font-size: 20px;
      }
      .content-description {
        font-size: 20px;
      }
    }
  }
  .trailer-btn {
    img {
      width: 35px;
    }
  }
  .movie-tags {
    p {
      font-size: 20px;
    }
  }
  .overview-right {
    img.play {
      margin-top: 30%;
      margin-left: 35%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Templates/ContentDetailCard.vue